var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"fj-env",rawName:"v-fj-env"},{name:"fj-touch",rawName:"v-fj-touch"}],staticClass:"sns-link",on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }